import { Box } from '@mui/material';
import React from 'react';
import { motion } from 'framer-motion';

const LogoPartner = (props) => {
    return (
        <motion.div
            initial={{ opacity: 0.6, filter: 'grayscale(40%)' }}
            whileHover={{ opacity: 1, filter: 'grayscale(0%)', scale: 1.06 }}
            animate={{ opacity: 0.6, filter: 'grayscale(40%)' }}
            transition={{ duration: 0.3 }}
        >
            <Box
                component="img"
                src={props.image}
                sx={[
                    {
                        height: props.height,
                        width: props.width,
                        objectFit: 'contain',
                        display: 'block',
                        '@media (max-width: 768px)': {
                            height: 'auto',
                            width: '18vw',
                        },
                    },
                    ...(Array.isArray(props.sx) ? props.sx : props.sx ? [props.sx] : []),
                ]}
            />
        </motion.div>
    );
}

export default LogoPartner;